import { useState, useCallback } from 'react';

export const usePrompt = () => {
  const [promptState, setPromptState] = useState({
    isOpen: false,
    title: '',
    message: '',
    placeholder: '',
    defaultValue: '',
    submitText: 'Valider',
    cancelText: 'Annuler',
    onSubmit: null,
    isLoading: false
  });

  const prompt = useCallback(({
    title = 'Saisir une valeur',
    message = '',
    placeholder = '',
    defaultValue = '',
    submitText = 'Valider',
    cancelText = 'Annuler'
  } = {}) => {
    return new Promise((resolve) => {
      setPromptState({
        isOpen: true,
        title,
        message,
        placeholder,
        defaultValue,
        submitText,
        cancelText,
        onSubmit: resolve,
        isLoading: false
      });
    });
  }, []);

  const handleSubmit = useCallback(async (value) => {
    if (promptState.onSubmit) {
      setPromptState(prev => ({ ...prev, isLoading: true }));
      
      try {
        // Attendre un court délai pour l'animation
        await new Promise(resolve => setTimeout(resolve, 150));
        promptState.onSubmit(value);
      } finally {
        setPromptState(prev => ({ 
          ...prev, 
          isOpen: false, 
          isLoading: false,
          onSubmit: null 
        }));
      }
    }
  }, [promptState]);

  const handleCancel = useCallback(() => {
    if (promptState.onSubmit) {
      promptState.onSubmit(null);
    }
    setPromptState(prev => ({ 
      ...prev, 
      isOpen: false, 
      onSubmit: null,
      isLoading: false 
    }));
  }, [promptState]);

  return {
    prompt,
    promptProps: {
      isOpen: promptState.isOpen,
      title: promptState.title,
      message: promptState.message,
      placeholder: promptState.placeholder,
      defaultValue: promptState.defaultValue,
      submitText: promptState.submitText,
      cancelText: promptState.cancelText,
      isLoading: promptState.isLoading,
      onSubmit: handleSubmit,
      onClose: handleCancel
    }
  };
};

export default usePrompt;
